// extracted by mini-css-extract-plugin
export var container = "_97-0";
export var error = "_97-9";
export var label = "_97-5";
export var light = "_97-6";
export var md = "_97-3";
export var sm = "_97-2";
export var thin = "_97-8";
export var thinBold = "_97-7";
export var vertical = "_97-4";
export var xs = "_97-1";